import { ProjectsSummaryStats } from '../../../Api/Projects/projectsApi';
import { SrOnlyText } from '../../Atoms/Text';

const TILES: { key: keyof ProjectsSummaryStats; label: string; chipClass: string }[] = [
  { key: 'projectsAtRisk', label: 'Services at Risk', chipClass: 'bg-[#F9E5D9] text-[#333741]' },
  { key: 'assigned', label: 'Assigned', chipClass: 'bg-[#FFF4BB] text-[#765823]' },
  { key: 'inProgress', label: 'In Progress', chipClass: 'bg-[#EDF8C3] text-[#525F1D]' },
  { key: 'installed', label: 'Installed', chipClass: 'bg-[#E5EDFF] text-[#3F527F]' },
  { key: 'totalProjects', label: 'Total Projects', chipClass: 'bg-[#DAD5F4] text-[#281D5F]' }
];

export interface ProjectsSummaryStatsWidgetProps {
  stats: ProjectsSummaryStats;
}

// Scoped to the one count the API is still rolling out — a blank chip anywhere else is a fault worth seeing.
const TileValue = ({ stats, tileKey }: { stats: ProjectsSummaryStats; tileKey: keyof ProjectsSummaryStats }) => {
  if (tileKey !== 'assigned' || stats.assigned !== undefined) return <>{stats[tileKey]}</>;

  return (
    <>
      <span aria-hidden="true">—</span>
      <SrOnlyText isSpan>Not available</SrOnlyText>
    </>
  );
};

export const ProjectsSummaryStatsWidget = ({ stats }: ProjectsSummaryStatsWidgetProps) => (
  <div
    className="flex items-center gap-4"
    data-testid="projects-summary-stats">
    {TILES.map(({ key, label, chipClass }) => (
      <div
        key={key}
        className="flex items-center gap-3 flex-1 rounded-md px-3 py-2"
        data-testid={`summary-stat-${key}`}
        data-cy={`summary-stat-${key}`}>
        <div
          className={`${chipClass} rounded-md min-w-10 h-10 px-2 flex items-center justify-center text-lg font-bold`}>
          <TileValue
            stats={stats}
            tileKey={key}
          />
        </div>
        <div className="text-sm text-white font-medium leading-tight">{label}</div>
      </div>
    ))}
  </div>
);
